import {
  IHeaderTextPageElement,
  ISubHeaderTextPageElement,
  IBodyTextPageElement,
  IPageDividerElementConfig,
  IPageDividerPageElement,
  ITasksElementConfig,
  ITasksPageElement,
  IOfferSelectionElementConfig,
  IOfferSelectionPageElement,
  IImageElementConfig,
  IImagePageElement,
  IButtonElementConfig,
  IButtonPageElement,
  ITextElementConfig,
  IDataInputPageElement,
  IDataInputElementConfig,
  IProgressBarPageElement,
  IProgressBarElementConfig,
  IESignatureElement,
  IESignatureElementConfig,
  ITextColumnsElement,
  ITextColumnsElementConfig,
  ISelectionOptionsElement,
  ISelectionOptionsElementConfig,
  PortalPageElementType,
  IPlaidLinkPageElement,
  IPlaidLinkElementConfig,
  ICustomHtmlElementConfig,
  ICustomHtmlPageElement,
} from './portal-page-elements';
import BasePortalPageElementsRestApi, {
  IPortalPageElementsApi,
} from './portal-page-elements/BasePortalPageElementsApi';

export type ITextPageElement =
  | IHeaderTextPageElement
  | ISubHeaderTextPageElement
  | IBodyTextPageElement;

export type IPortalPageElement =
  | ITextPageElement
  | IPageDividerPageElement
  | ITasksPageElement
  | IOfferSelectionPageElement
  | IImagePageElement
  | IButtonPageElement
  | IDataInputPageElement
  | IProgressBarPageElement
  | ICustomHtmlPageElement
  | IESignatureElement
  | ITextColumnsElement
  | ISelectionOptionsElement
  | IPlaidLinkPageElement;

export type IPageElementConfig =
  | ITextElementConfig
  | IPageDividerElementConfig
  | ITasksElementConfig
  | IOfferSelectionElementConfig
  | IImageElementConfig
  | IButtonElementConfig
  | IDataInputElementConfig
  | IProgressBarElementConfig
  | ICustomHtmlElementConfig
  | IESignatureElementConfig
  | ITextColumnsElementConfig
  | ISelectionOptionsElementConfig
  | IPlaidLinkElementConfig;

export interface IFindPortalPageElementsParams {
  statusId: string;
}

export default class PortalPageElementsRestApi
  extends BasePortalPageElementsRestApi<PortalPageElementType, IPortalPageElement, IFindPortalPageElementsParams>
  implements IPortalPageElementsApi<
    IPortalPageElement,
    IFindPortalPageElementsParams
  > {
  protected resourceName = 'portal-page-elements';
}
